var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopTableIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow",
    cx: 22.5,
    cy: 23.1817,
    rx: 22.5,
    ry: 21.8182,
    fill: "#E7F9F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.2596 23.8362H24.2721L24.0471 24.9271C23.9627 25.3635 24.2439 25.7999 24.6939 25.8817C24.7502 25.8817 24.8064 25.909 24.8627 25.909C25.2564 25.909 25.5939 25.6362 25.6783 25.2544L25.9877 23.8362H28.0689L27.8439 24.9271C27.7596 25.3635 28.0408 25.7999 28.4908 25.8817C28.5471 25.8817 28.6033 25.909 28.6596 25.909C29.0533 25.909 29.3908 25.6362 29.4752 25.2544L29.7846 23.8362H31.1064C31.5564 23.8362 31.9502 23.4817 31.9502 23.0181C31.9502 22.5817 31.5846 22.1999 31.1064 22.1999H30.0939L30.4596 20.4817H31.8096C32.2596 20.4817 32.6533 20.1271 32.6533 19.6635C32.6533 19.2271 32.2877 18.8453 31.8096 18.8453H30.7971L31.0221 17.7544C31.1064 17.3181 30.8252 16.8817 30.3752 16.7999C29.9252 16.7181 29.4752 16.9908 29.3908 17.4271L29.0814 18.8453H27.0002L27.2252 17.7544C27.3096 17.3181 27.0283 16.8817 26.5783 16.7999C26.1283 16.7181 25.6783 16.9908 25.5939 17.4271L25.3127 18.8999H23.9908C23.5408 18.8999 23.1471 19.2544 23.1471 19.7181C23.1471 20.1544 23.5127 20.5362 23.9908 20.5362H24.9471L24.5814 22.2544H23.2314C22.7814 22.2544 22.3877 22.609 22.3877 23.0726C22.4158 23.4817 22.7814 23.8362 23.2596 23.8362ZM26.6908 20.509H28.7721L28.4064 22.2271H26.3252L26.6908 20.509Z",
    fill: "#05BC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.1094 23.1818C20.5594 23.1818 20.9531 22.8273 20.9531 22.3636V17.5909C20.9531 17.1545 20.5875 16.7727 20.1094 16.7727C19.6594 16.7727 19.2656 17.1273 19.2656 17.5909V22.3909C19.2656 22.8 19.6594 23.1818 20.1094 23.1818Z",
    fill: "#05BC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.1095 25.9635C20.6842 25.9635 21.1501 25.5117 21.1501 24.9544C21.1501 24.3971 20.6842 23.9453 20.1095 23.9453C19.5348 23.9453 19.0688 24.3971 19.0688 24.9544C19.0688 25.5117 19.5348 25.9635 20.1095 25.9635Z",
    fill: "#05BC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.9063 25.9635C15.4811 25.9635 15.947 25.5117 15.947 24.9544C15.947 24.3971 15.4811 23.9453 14.9063 23.9453C14.3316 23.9453 13.8657 24.3971 13.8657 24.9544C13.8657 25.5117 14.3316 25.9635 14.9063 25.9635Z",
    fill: "#05BC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.9378 19.5543C13.3878 19.6907 13.8378 19.4725 13.9784 19.0362C14.119 18.6271 14.5971 18.2725 15.1878 18.4362C15.4971 18.518 15.7503 18.7634 15.8346 19.0634C15.919 19.3362 15.8628 19.6089 15.7221 19.8543C15.5815 20.0725 15.3284 20.2362 15.0471 20.2634C14.4846 20.3452 14.0628 20.8362 14.0628 21.4089V22.3634C14.0628 22.7998 14.4284 23.1816 14.9065 23.1816C15.3846 23.1816 15.7503 22.8271 15.7503 22.3634V21.7634C16.3128 21.5725 16.7909 21.218 17.1284 20.7271C17.5503 20.1271 17.6628 19.3634 17.4659 18.6543C17.2409 17.7816 16.5096 17.0998 15.6378 16.8543C14.2596 16.4998 12.8815 17.2089 12.4315 18.518C12.2628 18.9543 12.4878 19.418 12.9378 19.5543Z",
    fill: "#05BC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M35.0156 13.6362H9.98437C9.53437 13.6362 9.14062 13.9908 9.14062 14.4544V28.2817C9.14062 28.718 9.50625 29.0999 9.98437 29.0999H13.5V32.5362C13.5 32.8635 13.6969 33.1362 14.0062 33.2726C14.1187 33.3271 14.2312 33.3271 14.3437 33.3271C14.5406 33.3271 14.7375 33.2453 14.9062 33.109L19.4062 29.0726H35.0156C35.4656 29.0726 35.8594 28.718 35.8594 28.2544V14.4544C35.8594 14.018 35.4937 13.6362 35.0156 13.6362ZM34.2 27.4635H19.0687C18.8719 27.4635 18.6469 27.5453 18.5062 27.6817L15.1594 30.6817V28.2817C15.1594 27.8453 14.7937 27.4635 14.3156 27.4635H10.8V15.2726H34.1719V27.4635H34.2Z",
    fill: "#05BC86"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_2",
    cx: 22.5,
    cy: 21.8182,
    rx: 22.5,
    ry: 21.8182,
    fill: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 43269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style=linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M26.5 30.2167H17.5C14.8 30.2167 13 28.8667 13 25.7167V19.4167C13 16.2667 14.8 14.9167 17.5 14.9167H26.5C29.2 14.9167 31 16.2667 31 19.4167V25.7167C31 28.8667 29.2 30.2167 26.5 30.2167Z",
    stroke: "#0078E6",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M28.0931 18.7585L23.1008 22.6162C22.4525 23.1171 21.5478 23.1171 20.8995 22.6162L15.9072 18.7585",
    stroke: "#0078E6",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopTableIcon4);
export default __webpack_public_path__ + "static/media/TopTableIcon4.41e4fe1d90dba6a6ab53b8c83c19b66f.svg";
export { ForwardRef as ReactComponent };